import { useParams } from "react-router-dom";

interface UseParamsType {
  lectureNum?: string;
}

export default function LectureNumParams() {
  return Number(useParams<UseParamsType>()["lectureNum"]);
}
